import { render } from "./PostView.vue?vue&type=template&id=6610b1ac&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=6610b1ac&scoped=true&lang=css"

import exportComponent from "../../../../../var/www/cry4change/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6610b1ac"]])

export default __exports__